<template>
  <el-container>
    <el-main>
        <div>
            <el-row>
                <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                    <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                        <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                    </el-tooltip>
                </el-col>
                <el-col :span="12">
                    <h3>项目明细</h3>
                </el-col>
            </el-row>
            <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
            <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC">
                <el-row>
                    <el-col :span="24">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="addItemPage" v-bind:disabled="enableBtn.xz">新增</el-button>
                        <el-button type="primary" size="small" icon="el-icon-edit" @click="updateItem" v-bind:disabled="enableBtn.xg">修改</el-button>
                        <el-button type="primary" size="small" icon="el-icon-delete" @click="onDel" v-bind:disabled="enableBtn.sc">删除</el-button>
                        <el-button type="primary" size="small" icon="el-icon-upload" @click="importAux" v-bind:disabled="enableBtn.dr">导入</el-button>
                        <el-button type="primary" size="small" icon="el-icon-download" @click="exportAuxMould" v-bind:disabled="enableBtn.xzmb">下载模板</el-button>
                    </el-col>
                </el-row>
                <el-form ref="form" :model="form" :rules="formRules" v-loading="showLoading">
                    <el-table ref="singleTable" :data="recordData" highlight-current-row 
                        style="width: 100%; height:30%; overflow: auto;" @selection-change="handleSelectionChange" 
                        :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                        <!-- <el-table-column property="choice" label="选择" align="center" width="100">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.$index+1" :v-model="scope.auxItemCode" @change.native="getCurrentRow(scope.row, scope)"></el-checkbox>
                            </template>
                        </el-table-column> -->
                        <el-table-column type="selection" width="45"></el-table-column>
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column property="auxItemCode" label="收费明细项目编码" width="150" show-overflow-tooltip="true"></el-table-column>
                        <el-table-column property="auxItemName" label="收费明细项目名称" width="150" show-overflow-tooltip="true"></el-table-column>
                        <el-table-column property="auxItemUnit" label="收费明细项目单位" width="150" show-overflow-tooltip="true"></el-table-column>
                        <el-table-column property="auxItemStd" label="收费明细项目标准" width="150" show-overflow-tooltip="true"></el-table-column>
                        <el-table-column property="auxItemRemark" label="收费明细项目备注" width="200" show-overflow-tooltip="true"></el-table-column>
                    </el-table>
                    <el-row style="margin: 18px 8px">
                        <el-col :span="24">
                            <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                                :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                                @pagination="onFilter" />
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <el-dialog
          :title="view.dialogTitle"
          :append-to-body="true"
          :width="'80%'"
          :visible.sync="view.showItemAux"
        >
          <Itemauxedit v-if="view.showItemAux"  @reload="onFilter"  v-bind:entity="entityData"></Itemauxedit>
        </el-dialog>

        <el-dialog
           title="导入项目明细"
          :append-to-body="true"
          :width="'80%'"
          :visible.sync="view.showUploadauxAux"
        >
          <Uploadaux v-if="view.showUploadauxAux"  @reload="onFilter"  v-bind:entity="entityData"></Uploadaux>
        </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
    import _ from "lodash"
    import Itemauxedit from "./itemauxedit.vue";
    import Uploadaux from "./uploadaux.vue";

    let _kits, _form, _table
    export default {
        components: {
            Itemauxedit, Uploadaux
        },
        props: ["entity", "mode"],
        data() {
            let form = {
                agencyCode: this.entity.agencyCode,
                itemCode: this.entity.itemCode,
                itemName: this.entity.itemName
            }
            let data = {
                enableBtn: { //控制启用禁用
                    sc: false,
                    xz: false,
                    dr: false,
                    xzmb: false,
                    xg: false
                },
                layout: {
                    loading: true
                },
                view: {
                    showItemAux: false,
                    showUploadauxAux: false,
                    dialogTitle:""
                },
                multipleSelection: [],
                radio: "",
                recordData: [], //展示信息
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                einvtypeCodeOptions: [],
                form,
                formRules: {
                }
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            onFilter() {
                this.layout.loading = true;
                _table.load();
                this.view.showItemAux = false;
                this.view.showUploadauxAux = false;
                this.radio = "";
            },
            addItemPage() {
                this.entityData = {
                    agencyCode: this.form.agencyCode,
                    itemCode: this.form.itemCode,
                    itemName: this.form.itemName
                };
                this.view.dialogTitle ="新增项目明细";
                this.view.showItemAux = true
            },
            updateItem() {
                if (this.checkSelect()) {
                    return;
                }
                console.log(this.multipleSelection[0]);
               this.entityData = {
                    agencyCode: this.form.agencyCode,
                    itemCode: this.form.itemCode,
                    itemName: this.form.itemName,
                    auxItemCode: this.multipleSelection[0].auxItemCode,
                    auxItemName: this.multipleSelection[0].auxItemName,
                    auxItemUnit: this.multipleSelection[0].auxItemUnit==null?"":this.multipleSelection[0].auxItemUnit,
                    auxItemStd: this.multipleSelection[0].auxItemStd==null?"":this.multipleSelection[0].auxItemStd,
                    auxItemRemark: this.multipleSelection[0].auxItemRemark
                };
                this.view.dialogTitle ="修改项目明细";
                this.view.showItemAux = true
            },
            checkSelect() {
                if (this.multipleSelection.length != 1) {
                    this.$alert("请先选择一条记录");
                    return true;
                }
                return false;
            },
            onDel() {
                if (this.multipleSelection.length < 1) {
                    this.$alert("请至少选择一条记录");
                    return;
                }
                _kits.confirm({
                    text: "确定删除单位项目明细?",
                    yes: () => {
                        this.layout.loading = true
                        _kits.message("正在删除")
                        _kits.api.update(
                            "DELAGENCYITEMAUX", {
                                agencyCode: this.form.agencyCode,
                                itemCode: this.form.itemCode,
                                multipleSelection: this.multipleSelection
                            },
                            () => {
                                _table.load();
                                this.radio="";
                            }
                        )
                   }
                });
            },
            importAux() {
                this.entityData = {
                    agencyCode: this.form.agencyCode,
                    itemCode: this.form.itemCode,
                    itemName: this.form.itemName
                };
                this.view.showUploadauxAux = true
            },
            exportAuxMould() {
                this.layout.loading = true
                _kits.message("正在下载")
                _kits.api.call(
                    "DOWNLOADITEMAUXMODEL", { },
                    result => {
                        console.log(result);
                        if (result.returnCode == "0000") {
                            this.downloadBase64(result.data.fileName, result.data.fileBase64)
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                );
            },
            downloadBase64(fileName, base64) {
                let data_head = 'data:;base64,'
                let a = document.createElement('a')
                a.download = fileName
                a.href = data_head + base64
                document.querySelector("body").appendChild(a)
                a.click()
                document.querySelector("body").removeChild(a)
            },
            init() {
                this.radio = "";
                _table.load()
            },
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits();
            _table = _kits.table(
                "GETAGENCYITEMAUXBYITEMCODE",
                () => {
                    this.isShowLoading = true;
                    return Object.assign({}, this.form, this.pagination);
                },
                result => {
                    this.isShowLoading = false;
                    this.isShowLoading = false;
                    this.recordData = result.list;
                    this.pagination.total = Number.parseInt(result.total);
                }
            );
            this.init()
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "SAVEAGENCYITEM" : "UPDATEAGENCYITEM"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
